import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { ShareEntityModel, TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v1/email";
const slApiUrl = "/api/v1/supplyland";

const emailSubscriptionUrl = "/email";

export interface TellAFriendApiParameter extends ApiParameter {
    tellAFriendModel: TellAFriendModel;
}

export interface SubscribeToListApiParameter extends ApiParameter {
    emailAddress: string;
}

export interface ShareEntityApiParameter extends ApiParameter {
    shareEntityModel: ShareEntityModel;
    url: string;
}

export interface ShareEntityGenerateFromWebpageApiParameter {
    shareEntityModel: ShareEntityModel;
    urlPathToLoadForAttachmentHtml: string;
}

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    formName?: string;
    firstName?: string;
    lastName?: string;
    message?: string;
    topic?: string;
    topicLabel?: string;
    emailAddress?: string;
    emailTo?: string;
    phoneNumber?: string;
    textField1?: string;
    textField1Label?: string;
    textField2?: string;
    textField2Label?: string;
    textField3?: string;
    textField3Label?: string;
    textField4?: string;
    textField4Label?: string;
    textField5?: string;
    textField5Label?: string;
    textField6?: string;
    textField6Label?: string;
    textField7?: string;
    textField7Label?: string;
    textField8?: string;
    textField8Label?: string;
    textField9?: string;
    textField9Label?: string;
    textField10?: string;
    textField10Label?: string;
    textField11?: string;
    textField11Label?: string;
    textField12?: string;
    textField12Label?: string;
    textField13?: string;
    textField13Label?: string;
    textField14?: string;
    textField14Label?: string;
    textField15?: string;
    textField15Label?: string;
    numericField1?: string;
    numericField1Label?: string;
    numericField2?: string;
    numericField2Label?: string;
    numericField3?: string;
    numericField3Label?: string;
    numericField4?: string;
    numericField4Label?: string;
    numericField5?: string;
    numericField5Label?: string;
    numericField6?: string;
    numericField6Label?: string;
    numericField7?: string;
    numericField7Label?: string;
    numericField8?: string;
    numericField8Label?: string;
    numericField9?: string;
    numericField9Label?: string;
    numericField10?: string;
    numericField10Label?: string;
}

export function tellAFriend(parameter: TellAFriendApiParameter) {
    return post<TellAFriendModel>(`${emailsUrl}/tellafriend`, parameter.tellAFriendModel);
}

export function shareEntity(parameter: ShareEntityApiParameter) {
    return post<ShareEntityModel>(parameter.url, parameter.shareEntityModel);
}

export function shareEntityGenerateFromWebpage(parameter: ShareEntityGenerateFromWebpageApiParameter) {
    return post<ShareEntityGenerateFromWebpageApiParameter, ShareEntityModel>("/.spire/shareEntity", parameter);
}

export function subscribeToList(parameter: SubscribeToListApiParameter) {
    return post<SubscribeToListApiParameter>(`${emailSubscriptionUrl}/SubscribeToList`, parameter);
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${slApiUrl}/SubmitContactUs`, parameter);
}

export function subscribeToCouponList(parameter: SubscribeToListApiParameter) {
    return post<SubscribeToListApiParameter>(`${emailSubscriptionUrl}/SubscribeToCouponList`, parameter);
}
